<template>
  <section id="advantages" class="section advantages-section">
    <div class="container">
      <div class="section-title" data-aos="fade-up">
        <h2 style="color: white">{{ $t("advantages.title") }}</h2>
        <div class="section-title-subtitle">{{ $t("advantages.subtitle") }}</div>
      </div>

      <div class="advantages-grid">
        <div v-for="(item, index) in $t('advantages.items')" :key="index" class="advantage-card" :data-aos="'zoom-in'" :data-aos-delay="index * 150">
          <div class="advantage-icon">
            <div class="icon-wrapper">
              <i :class="item.icon"></i>
            </div>
          </div>
          <div class="advantage-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <ul class="advantage-features">
              <li v-for="(feature, idx) in item.features" :key="idx"><i class="el-icon-check"></i> {{ feature }}</li>
            </ul>
          </div>
          <div class="advantage-number">{{ String(index + 1).padStart(2, "0") }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AdvantagesSection",
};
</script>

<style scoped>
.advantages-section {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  position: relative;
  overflow: hidden;
}

.advantages-section::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 50%;
}

.section-title h2 {
  font-size: 42px;
  color: white;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
  margin-top: 40px;
}
.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: white;
  border-radius: 2px;
}

.advantages-section::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
}

.advantages-section::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 50%;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 40px;
  position: relative;
  z-index: 1;
}
.section-title-subtitle {
  color: white;
  font-size: 18px;
  margin-top: 25px;
}

.advantage-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(78, 106, 122, 0.15);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.advantage-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #3194b2, #31a7d2);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.advantage-card:hover::before {
  transform: scaleX(1);
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(49, 148, 178, 0.25);
}

.advantage-icon {
  margin-bottom: 25px;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
  box-shadow: 0 8px 20px rgba(78, 106, 122, 0.2);
  transition: all 0.4s ease;
  background: linear-gradient(135deg, var(--icon-gradient-start), var(--icon-gradient-end));
}

.advantage-card:hover .icon-wrapper {
  transform: rotate(10deg) scale(1.1);
}

.advantage-content h3 {
  font-size: 26px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.advantage-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 15px;
}

.advantage-features {
  list-style: none;
  padding: 0;
}

.advantage-features li {
  padding: 10px 0;
  color: #555;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.advantage-features li:last-child {
  border-bottom: none;
}

.advantage-features li:hover {
  padding-left: 10px;
  color: #3194b2;
}

.advantage-features i {
  color: #31a7d2;
  margin-right: 10px;
  font-weight: bold;
}

.advantage-number {
  position: absolute;
  bottom: 20px;
  right: 30px;
  font-size: 80px;
  font-weight: bold;
  color: rgba(49, 148, 178, 0.05);
  line-height: 1;
}

@media (max-width: 768px) {
  .advantages-grid {
    grid-template-columns: 1fr;
  }
}
</style>
